(function () {
    "use strict";

    angular
        .module('showcaseApp')
        .controller('HubFlyersFormController', HubFlyersFormController)
        .directive('hubFileChange', function () {
            return {
                restrict: "A",
                scope: {
                    fileChange: "&",
                },
                link: function (scope, element, attrs) {
                    element.on('change', function (event) {
                        scope.$apply(function () {
                            scope.fileChange({ $event: event });
                        });
                    });

                    scope.$on('$destroy', function () {
                        element.off('change');
                    });
                },
            };
        });

    function HubFlyersFormController($translate, $timeout, $scope, $window, $localStorage, $q, $state, $uibModal, $stateParams, toastr, moment,
        FlyerCategoryService, StoreService, FlyersService, BrandService, ColorService, ShowcasesService, Principal,
        ErpsSettingsService, $rootScope, GoogleMapsService, HubFlyersService, $document, NgMap) {

        const MAX_IMAGE_SIZE = 10240;
        const ICON_ACTIVE = 'https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/' + $rootScope.urlImage + '/pointactive.png';
        const ICON_INACTIVE = 'content/images/pointinactive.png';
        const DATE_FORMAT = $translate.instant('momentDateFormat');
        const DATE_TIME_FORMAT = $translate.instant('momentDateTime24HFormat');
        const now = moment(moment(), DATE_FORMAT).toDate();
        const SRC_IMAGE_DEFAULT = 'content/images/1-image-default-product.png';
        const SRC_IMAGE_DETAIL_DEFAULT = 'content/images/2-image-default-product_mini-alt.png';
        const UPLOAD_IMAGE_CONTEXT = 'image';
        const UPLOAD_VIDEO_CONTEXT = 'video';
        const DEFAULT_PAGE = '0';
        const DEFAULT_ITEMS_PER_PAGE = '1000';

        const LINK_ADDRESS_GOOGLE = 'https://www.google.com/maps/search/?api=1&query=';

        var vm = this;

        vm.$onInit = init;

        loadErpConfiguration();

        vm.configuration = null;
        vm.regexForValueZero = '([1-9]{1}[0-9]{0,2})(\.[0-9]{3})*\,[0-9]{2}|[0-9]{0,3}(\.[0-9]{3})*\,([0-9][1-9]|[1-9][0-9])';
        vm.isEdit = false;
        vm.isLoading = true;
        vm.currencyConfigurations = getCurrencyListConfiguration();
        vm.transactionalUserInteractions = ["RENT", "SALE"];

        vm.enableDemoVideo = false;
        vm.hasLinkVideo = true;
        vm.hasFileVideo = false;
        vm.fileName = "";
        vm.fileSize = "";

        vm.isImmoContext = $localStorage.defaultStore.immoContext;
        vm.isHubContext = $localStorage.defaultStore.hubContext;

        vm.toggleFileVideo = function (type) {
            if (type === "link") {
                vm.hasLinkVideo = true;
                vm.hasFileVideo = false;
            } else {
                vm.hasLinkVideo = false;
                vm.hasFileVideo = true;
            }
        }

        vm.srcImgDefault = SRC_IMAGE_DEFAULT;
        vm.srcImgDetailDefault = SRC_IMAGE_DETAIL_DEFAULT;
        vm.imgsFlyers = []

        vm.imgsPlants = []

        vm.getTranslateKey = function (baseKey) {
            return getTranslateKey(vm.isImmoContext, baseKey)
        };

        vm.listBlobs = [];

        $scope.windowWidth = $window.innerWidth;

        $window.onresize = function (event) {
            $timeout(function () {
                $scope.windowWidth = $window.innerWidth;
            });
        };

        $scope.$watch(
            function () {
                return document.getElementById("content").clientWidth;
            },
            function (newVal, oldVal) {
                if (!document.getElementById("brand")) return;
                if (newVal - oldVal > 20 || oldVal - newVal > 20) {
                    var autoChild =
                        document.getElementById("brand").firstElementChild;
                    var el = angular.element(autoChild);
                    el.scope().$mdAutocompleteCtrl.hidden = true;
                }
            }
        );

        // Auxiliaries for brand entities
        vm.querySearchBrand = querySearchBrand;
        vm.selectedBrandChange = selectedBrandChange;
        vm.newBrand = newBrand;
        vm.brands = [];

        // Auxiliaries for category entities
        vm.querySearchCategory = querySearchCategory;
        vm.selectedCategoryChange = selectedCategoryChange;
        vm.newCategory = newCategory;

        // Auxiliaries for color entities
        vm.querySearchColor = querySearchColor;
        vm.searchVariationColor = searchVariationColor;
        vm.selectedColorChange = selectedColorChange;
        vm.newVariationColor = newVariationColor;
        vm.editVariationColor = editVariationColor;
        vm.selectVariationColor = selectVariationColor;
        vm.colors = [];
        vm.allColors = [];
        vm.newColor = newColor;

        vm.imageSize = 600;
        vm.flyerImage = "";
        vm.firstZoom = true;
        vm.isSaving = false;
        vm.selectedSizes = [];

        vm.isMobile = detectar_mobile();

        vm.enableTags = false;
        vm.enableDimension = false;
        vm.enableSchedules = false;
        vm.enableBatchSale = false;
        vm.enableRules = false;
        vm.enableMeasures = false;

        vm.measureList = [];
        vm.capitalize = function (str) {
            if (typeof str !== "string") {
                return "";
            }
            return str.charAt(0).toUpperCase() + str.substr(1).toLowerCase();
        };

        vm.flyer = {
            discountPercentageValue: undefined,
            currency: "REAL",
            currencyInstance: vm.currencyConfigurations.REAL,
            discountType: "DISCOUNT_FIXED",
            details: [
                {
                    size: $translate.instant("flyers.detail.unique"),
                    color: undefined,
                    purchaseValue: undefined,
                    discountedValue: undefined,
                    inventory: undefined,
                    quantityByPerson: undefined,
                    measureList: [],
                    unit: undefined,
                    type: undefined,
                    meters: undefined,
                    position: undefined,
                    bedroom: undefined,
                    parking: undefined,
                    bathroom: undefined,
                    status: 'available',
                }
            ],
            tags: [],
            isLaunch: false,
            isBasic: false,
            isDelivered: false,
            validityTypeDate: false,
            isPublished: false,
            incorporationRegister: "",
            productReference: generateProductReference(),
            addImageFileDTO: [],
            type: "SALE",
            address: {
                latitude: 0,
                longitude: 0,
                street: "",
                number: "",
                district: "",
                city: "",
                state: "",
                cep: "",
                link: "",
            },
            video: {
                path: "",
                keyName: "",
                originalName: "",
                fileType: "",
                inUse: false,
                size: 0,
            },
            flyerImages: [],
            blueprintImages: [],
        };

        vm.mainMap = {
            center: {
                latitude: -23.5505199,
                longitude: -46.633309
            },
            zoom: 16,
            controls: {},
            bounds: {},
            markers: [],
            window: {
                model: {},
                show: false,
                options: {
                    pixelOffset: {
                        width: -1,
                        height: -65,
                    },
                },
                closeClick: function () {
                    this.show = false;
                },
            },
            markerEvents: {
                dragend: function (marker) {
                    var lat = marker.getPosition().lat();
                    var lng = marker.getPosition().lng();
                    vm.mainMap.markers[0].latitude = lat;
                    vm.mainMap.markers[0].longitude = lng;
                    vm.flyer.address.latitude = lat;
                    vm.flyer.address.longitude = lng;
                    vm.flyer.address.link = LINK_ADDRESS_GOOGLE + lat + ',' + lng;
                    $scope.$apply();
                },
                mouseover: function (marker, eventName, model) {
                    vm.mainMap.window.model = model;
                    vm.mainMap.window.show = true;
                },
                mouseout: function () {
                    vm.mainMap.window.show = false;
                },
                click: function (marker) {
                    for (var i = 0; i < vm.mainMap.markers.length; i++) {
                        if (vm.mainMap.markers[i].id === marker.key) {
                            if (vm.mainMap.markers[i].clicked) {
                                vm.mainMap.markers[i].options.icon =
                                    ICON_INACTIVE;
                                vm.mainMap.markers[i].clicked = false;
                            } else {
                                vm.mainMap.markers[i].options.icon =
                                    ICON_ACTIVE;
                                vm.mainMap.markers[i].clicked = true;
                            }
                        }
                    }
                },
            },
        };

        vm.onMarkerDragEnd = function (event) {
            var lat = event.latLng.lat();
            var lng = event.latLng.lng();
            if (vm.mainMap.markers && vm.mainMap.markers.length > 0) {
                vm.mainMap.markers[0].latitude = lat;
                vm.mainMap.markers[0].longitude = lng;
            }
            vm.flyer.address.latitude = lat;
            vm.flyer.address.longitude = lng;
            vm.flyer.address.link = LINK_ADDRESS_GOOGLE + lat + "," + lng;
            $scope.$apply();
        };

        vm.onMarkerClick = function (event, m) {
            NgMap.getMap().then(function (map) {
                map.showInfoWindow("info-" + m.id, event.target);
            });
            if (vm.mainMap.markers && vm.mainMap.markers.length > 1) {
                for (var i = 0; i < vm.mainMap.markers.length; i++) {
                    if (vm.mainMap.markers[i].id === m.id) {
                        vm.mainMap.markers[i].clicked = !vm.mainMap.markers[i].clicked;
                        vm.mainMap.markers[i].options.icon =
                            vm.mainMap.markers[i].clicked ? ICON_ACTIVE : ICON_INACTIVE;
                        break;
                    }
                }
            }
        };

        vm.sortableOptionsFlyer = {
            connectWith: ".images-container-uploaded",
        };

        vm.hasBlueprint = false;

        vm.genderOptions = [
            {
                id: "1",
                title: $translate.instant("flyers.new.form.gender.male"),
            },
            {
                id: "2",
                title: $translate.instant("flyers.new.form.gender.female"),
            },
            {
                id: "3",
                title: $translate.instant("flyers.new.form.gender.both"),
            },
        ];

        vm.filterOptions = [
            { value: "sold", label: $translate.instant('flyers.status.sold') },
            { value: "reserved", label: $translate.instant('flyers.status.reserved') },
            { value: "available", label: $translate.instant('flyers.status.available') }
        ];

        vm.selectedFilterStatus = [];
        vm.searchTerm = "";

        vm.selectedConfigurations = [];

        function init() {
            getTableHeaderOptions();
            getAllColors();

            if ($stateParams.id) {
                vm.isEdit = true;
                loadStore().then(function () {
                    loadFlyer($stateParams.id);
                });
            } else {
                loadStore().then(function () {
                    loadData();
                    initializeDropdownOptions();
                    vm.flyer.currencyInstance = loadCurrencyPrefix(vm.store);
                });
            }
        }

        vm.isStatusSelected = function (status) {
            if (!vm.selectedFilterStatus || vm.selectedFilterStatus.length === 0) {
                return true;
            }
            return vm.selectedFilterStatus.some(function (item) {
                return item.value === status;
            });
        };

        function loadCurrencyPrefix(store) {
            var key = store.currency ? store.currency : "REAL";
            return getCurrencyListConfiguration()[key];
        }

        vm.onChangeEan = function (value, index) {
            if (
                value.ean === "" ||
                value.ean === null ||
                value.ean === undefined
            ) {
                return false;
            }
            for (var i = 0; i < vm.flyer.details.length; i++) {
                var details = vm.flyer.details[i];
                if (index !== i && value.ean === details.ean) {
                    return true;
                }
            }
            return false;
        };

        vm.checkIfLaunchSelected = function () {
            return vm.flyer.isLaunch;
        };

        function revalidateSizes() {
            for (var i = 0; i < vm.flyer.details.length; i++) {
                if (vm.flyerForm["varSize" + i].$invalid) {
                    vm.hasErrorSizeDuplicated(vm.flyer.details[i], i);
                }
            }
        }

        vm.hasErrorSizeDuplicated = function (value, index) {
            if (
                value.size === "" ||
                value.size === null ||
                value.size === undefined
            ) {
                vm.flyerForm["varSize" + index].$setValidity(
                    "duplicateSize",
                    true
                );
                return false;
            }
            for (var i = 0; i < vm.flyer.details.length; i++) {
                var details = vm.flyer.details[i];
                if (
                    index !== i &&
                    value.size === details.size && (
                        (value.color === null && details.color === null) ||
                        (value.color && details.color && value.color.id === details.color.id)
                    )

                ) {
                    vm.flyerForm["varSize" + index].$setValidity(
                        "duplicateSize",
                        false
                    );
                    return true;
                }
            }
            vm.flyerForm["varSize" + index].$setValidity(
                "duplicateSize",
                true
            );
            return false;
        };

        vm.applyConfigurations = function () {
            var selectedIds = (vm.selectedConfigurations || []).map(function (o) { return o.id; });
            vm.dropdownOptions.forEach(function (opt) {
                if (vm.flyer.hasOwnProperty(opt.id)) {
                    vm.flyer[opt.id] = selectedIds.indexOf(opt.id) > -1;
                }
            });
        };

        vm.openInput = function (evt) {
            document.getElementById("upload-photo").click();
        };

        vm.openInputPlant = function () {
            document.getElementById("upload-plant").click();
        };

        vm.clearAllPopovers = function () {
            Object.keys(vm).forEach(function (key) {
                if (String(key).includes("hidePopover")) {
                    delete vm[key];
                }
            });
        };

        vm.changeTags = function () {
            if (!vm.enableTags) {
                vm.flyer.tags = [];
            }
        };

        vm.changeDimension = function () {
            if (!vm.enableDimension) {
                if (vm.flyer.dimension) {
                    vm.flyer.dimension.weight = "";
                    vm.flyer.dimension.height = "";
                    vm.flyer.dimension.width = "";
                    vm.flyer.dimension.length = "";
                }
                vm.flyer.details.forEach(function (detail) {
                    detail.dimension = undefined;
                });
            }
        };

        vm.changeMeasure = function () {
            $timeout(function () {
                if (!vm.enableMeasures) {
                    if (vm.flyer.dimension) {
                        vm.flyer.measureList = [];
                    }
                    vm.flyer.details.forEach(function (detail) {
                        detail.measureList = [];
                    });
                    vm.measureList = [];

                    if (!vm.flyer.details.length) {
                        vm.flyer.measureList = [];
                    } else {
                        vm.flyer.details.forEach(function (detail) {
                            detail.measureList = [];
                        });
                    }
                } else {
                    vm.addMeasures();
                }
            });
        };

        vm.changeBatchSale = function () {
            if (!vm.enableBatchSale) {
                vm.flyer.bulkQuantity = undefined;
                vm.flyer.discountBulkPercentage = undefined;
            }
        };

        vm.changeRulesForUse = function () {
            if (!vm.enableRules) {
                vm.flyer.rulesForUse = undefined;
            }
        };

        vm.changeSchedules = function (enabled) {
            if (!enabled) {
                vm.flyer.startDate = undefined;
                vm.flyer.expirationDate = undefined;
                vm.flyer.immediateAvailability = true;
                vm.flyer.validityTypeDate = true;
            }
        };

        vm.onImmediateAvailabilityChange = function () {
            if (vm.flyer.immediateAvailability) {
                vm.flyerForm.startDate.$setValidity("minDate", true);
                angular
                    .element("#startDateTime")
                    .data("DateTimePicker")
                    .clear();
            }
        };

        vm.onValidityTypeDateChange = function (checked) {
            if (checked) {
                angular
                    .element("#expirationDateTime")
                    .data("DateTimePicker")
                    .clear();
            }
        };

        vm.loadImagesDeprecated = function (i) {
            if (i === -1) return;
            vm.imgsFlyers[0].isThumbnail = true;
            var random = new Date().getTime();
            var src = null;
            if (i != 0) {
                src =
                    "/flyer/api/" +
                    vm.flyer.id +
                    "__" +
                    i +
                    "/picture?type=large&ts=" +
                    random;
            } else {
                src =
                    "/flyer/api/" +
                    vm.flyer.id +
                    "/picture?type=large&ts=" +
                    random;
            }
            var img = new Image();
            img.src = src;
            img.id = i;
            img.onload = function () {
                vm.imgsFlyers[this.id].src = this.src;
                vm.imgsFlyers[this.id].isDefault = false;
                vm.moveImageFlyerToFirstIndex();
                vm.imgsFlyers.push({
                    id: vm.imgsFlyers[vm.imgsFlyers.length - 1].id + 1,
                    src: vm.srcImgDefault,
                    isDefault: true,
                    isThumbnail: false,
                });
                i = i + 1;
                vm.loadImages(i);
            };
            img.onerror = function () {
                vm.imgsFlyers[this.id].src = SRC_IMAGE_DEFAULT;
                vm.loadImages(-1);
            };

            this.$apply;
        };

        vm.getFileSize = function (size) {
            if (size < 1024) {
                return size + " B";
            } else if (size < 1048576) {
                return (size / 1024).toFixed(2) + " KB";
            } else if (size < 1073741824) {
                return (size / 1048576).toFixed(2) + " MB";
            } else {
                return (size / 1073741824).toFixed(2) + " GB";
            }
        };

        vm.loadImages = function () {
            if (!vm.flyer.flyerImages) {
                vm.flyer.flyerImages = [];
            }

            if (!vm.flyer.blueprintImages) {
                vm.flyer.blueprintImages = [];
            }

            var images = vm.flyer.imagesUrl;
            for (var i = 0; i < images.length; i++) {
                vm.imgsFlyers.push({
                    id: i,
                    src: images[i],
                    isDefault: false,
                    isThumbnail: false,
                });
            }
        };

        vm.typeChanged = function () {
            if (vm.flyer.type === "RENT") {
                vm.flyer.maxUsageByUser = 1;
                vm.flyer.maxUsages = 1;
                vm.flyer.usageLimitByUser = false;
                vm.flyer.validityTypeNumber = false;
                vm.flyer.validityTypeDate = true;
            }

            vm.flyer.bulkQuantity = null;
            vm.flyer.discountBulkPercentage = null;

            if (vm.transactionalUserInteractions.includes(vm.flyer.type)) {
                vm.disabledCurrency = true;
            } else {
                vm.disabledCurrency = false;
            }
        };

        vm.checkAllMarkers = function () {
            var icon;
            if (vm.allSalesPoint) {
                icon = ICON_ACTIVE;
            } else {
                icon = ICON_INACTIVE;
            }
            for (var i = 0; i < vm.mainMap.markers.length; i++) {
                vm.mainMap.markers[i].options.icon = icon;
                vm.mainMap.markers[i].clicked = vm.allSalesPoint;
            }
        };

        vm.checkDeleteOrderImage = function () {
            for (var i = 0; i < vm.flyer.addImageFileDTO.length; i++) {
                if (vm.flyer.addImageFileDTO[i].action === "DELETE") {
                    return true;
                }
            }
            return false;
        };

        vm.file = null;
        vm.isUploading = false;
        vm.isLoadingVideo = false;

        vm.openSelectVideo = function () {
            document.getElementById("videoUploadInput").click();
        };

        vm.loadFileVideo = function ($event) {
            var file = $event.target.files[0];

            vm.flyer.demoVideo = null;

            vm.file = file;
            vm.isLoadingVideo = true;
            vm.importResult = null;
            vm.errorSummary = null;

            if (file) {
                var fileReader = new FileReader();
                vm.isSaving = true;
                vm.isUploading = true;
                fileReader.onload = function () {
                    HubFlyersService.uploadVideo(file, UPLOAD_VIDEO_CONTEXT).then(
                        function (response) {
                            vm.flyer.video = response.data;
                            vm.isSaving = false;
                            vm.isUploading = false;
                            vm.fileName = response.data.originalName;
                            vm.fileSize = response.data.size;
                        }
                    ).catch(function (error) {
                        if (error.data && error.data.description) {
                            if (error.data.description === "Unsupported video format") {
                                toastr.error($translate.instant("flyers.messages.error.video.file-format"));
                            } else if (error.data.description.startsWith("The video file size exceeded the size limit of")) {
                                toastr.error($translate.instant("flyers.messages.error.video.limit-size"));
                            } else {
                                if (error.data.description) {
                                    toastr.error(error.data.description);
                                } else {
                                    toastr.error($translate.instant("flyers.messages.error.video"));
                                }
                            }
                        } else {
                            toastr.error($translate.instant("flyers.messages.error.video"));
                        }
                        vm.isSaving = false;
                        vm.isUploading = false;
                        $scope.$apply(function () {
                            vm.fileName = '';
                            vm.fileSize = '';
                        });
                    });
                };
                fileReader.readAsDataURL(file);
                vm.isLoadingVideo = false;
            } else {
                vm.isLoadingVideo = false;
            }
        };

        vm.clearFileVideo = function () {
            vm.file = null;
            vm.fileName = '';
            vm.fileSize = '';
            vm.flyer.video = null;
        }

        vm.saveFlyer = function () {
            if (vm.isSaving) {
                return;
            }
            vm.isSaving = true;
            if (vm.flyerForm.$invalid) {
                toastr.warning($translate.instant('error.invalid-fields'));
                angular.forEach(vm.flyerForm.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                    });
                });
                vm.isSaving = false;
                return;
            }

            if (vm.isImmoContext) {
                var units = [];
                for (var i = 0; i < vm.flyer.details.length; i++) {
                    if (units.includes(vm.flyer.details[i].unit)) {
                        toastr.warning($translate.instant('flyers.messages.create.duplicateUnit'));
                        vm.isSaving = false;
                        return;
                    }
                    units.push(vm.flyer.details[i].unit);
                }
            }


            if (vm.flyer.brand === null) {
                if (vm.isImmoContext) {
                    toastr.warning($translate.instant('brand.messages.warning.selectBrand-immo'));
                } else {
                    toastr.warning($translate.instant('brand.messages.warning.selectBrand'));
                }
                vm.isSaving = false;
                return;
            }

            if (vm.fullCategory === null && !vm.isImmoContext) {
                toastr.warning($translate.instant('categorys.messages.warning.selectCategory'));
                vm.isSaving = false;
                return;
            }

            if (!vm.hasBlueprint) {
                vm.flyer.blueprintImages = [];
            }

            if (!vm.enableDemoVideo) {
                vm.flyer.video = null;
            }

            if (vm.hasLinkVideo) {
                vm.flyer.video = null;
            } else {
                vm.flyer.demoVideo = null;
            }

            saveFlyer();
        }

        function loadStore() {
            return StoreService.getStore($localStorage.defaultStore.storeId).then(function (response) {
                vm.store = response.data;
                vm.defaultStoreCategory = response.data.categoryKey;
            });
        }


        function getAllColors() {
            ColorService.findColor("").then(
                function (response) {
                    vm.allColors = response.data.slice();
                }
            );
        }

        function initializeDropdownOptions() {
            vm.dropdownOptions = [
                {
                    id: "isLaunch",
                    label: $translate.instant("flyers.new.form.configurations.launch"),
                    value: "isLaunch",
                },
                {
                    id: "isBasic",
                    label: $translate.instant(vm.getTranslateKey("flyers.new.form.configurations.basic")),
                    value: "isBasic",
                },
            ];

            if (vm.isImmoContext) {
                vm.dropdownOptions.push({
                    id: "isDelivered",
                    label: $translate.instant("flyers.new.form.configurations.delivered"),
                    value: "isDelivered",
                });
            }

            syncSelectedConfigurationsFromFlyer();
        }

        function syncSelectedConfigurationsFromFlyer() {
            vm.selectedConfigurations = vm.dropdownOptions.filter(function (opt) {
                return !!vm.flyer[opt.id];
            });
        }


        function getTableHeaderOptions() {
            var marketOptions = [
                { key: "Photograph", label: "flyers.new.form.Photographs" },
                { key: "unit", label: "flyers.new.form.unit", required: true },
                { key: "type", label: "flyers.new.form.type", required: true },
                {
                    key: "meters",
                    label: "flyers.new.form.meters",
                    required: true,
                },
                { key: "position", label: "flyers.new.form.position" },
                { key: "bedroom", label: "flyers.new.form.bedroom" },
                { key: "parking", label: "flyers.new.form.parking" },
                { key: "bathroom", label: "flyers.new.form.bathroom" },
                {
                    key: "price",
                    label: "flyers.new.form.price",
                    required: true,
                },
                {
                    key: "status",
                    label: "flyers.new.form.status",
                    required: true,
                },
                { key: "actions", label: "flyers.selection-actions.actions" },
            ];

            var defaultOptions = [
                { key: "Photograph", label: "flyers.new.form.Photograph" },
                {
                    key: "color", label: "flyers.new.form.color"
                },
                {
                    key: "size",
                    label:
                        vm.defaultStoreCategory === "FASHION"
                            ? "flyers.new.form.size.title"
                            : "flyers.new.form.variation",
                    required: true,
                },
                { key: "inventory", label: "flyers.new.form.inventory" },
                {
                    key: "purchase-value",
                    label: "flyers.new.form.purchase-value",
                    required: true,
                },
                {
                    key: "discounted-value",
                    label: "flyers.new.form.discounted-value",
                },
                {
                    key: "quantity-by-person",
                    label: "flyers.new.form.quantity-by-person",
                },
                { key: "ean", label: "flyers.new.form.ean" },
                { key: "actions", label: "flyers.selection-actions.actions" },
            ];

            vm.headerTableFields = vm.isImmoContext ? marketOptions : defaultOptions;
        }

        function loadErpConfiguration() {
            ErpsSettingsService.getERPConfigurationByStoreId(
                $localStorage.defaultStore.storeId
            ).then(function (response) {
                if (response.data && response.data.id) {
                    vm.configuration = response.data;
                }
            });
        }

        function createJsonImage(uuid, extensionFile, orderNumber, action) {
            return {
                uuid: uuid,
                extensionFile: extensionFile,
                orderNumber: orderNumber,
                action: action
            };
        }

        vm.formatMoney = function (value, currencySymbol) {
            return formatMoney(
                value,
                currencySymbol,
                vm.flyer.currencyInstance.decimalQuant,
                vm.flyer.currencyInstance.centsSeparator,
                vm.flyer.currencyInstance.thousandsSeparator
            );
        };

        vm.checkDiscountedValue = function () {
            if (vm.flyer.purchaseValue && vm.flyer.discountedValue) {
                if (
                    parseFloat(vm.flyer.discountedValue) >
                    parseFloat(vm.flyer.purchaseValue)
                ) {
                    vm.flyerForm.discountedValue.$setValidity(
                        "discountGreaterThanValue",
                        false
                    );
                } else {
                    vm.flyerForm.discountedValue.$setValidity(
                        "discountGreaterThanValue",
                        true
                    );
                }
            }
        };

        vm.checkVariationDiscountedValue = function (index) {
            if (
                vm.flyer.details[index].purchaseValue &&
                vm.flyer.details[index].discountedValue
            ) {
                if (
                    vm.flyer.details[index].discountedValue >
                    vm.flyer.details[index].purchaseValue
                ) {
                    vm.flyerForm["varDiscountedValue" + index].$setValidity(
                        "discountGreaterThanValue",
                        false
                    );
                } else {
                    vm.flyerForm["varDiscountedValue" + index].$setValidity(
                        "discountGreaterThanValue",
                        true
                    );
                }
            }
        };

        vm.addDetail = function () {
            vm.flyer.details.push({
                size: undefined,
                color: undefined,
                purchaseValue: undefined,
                discountedValue: undefined,
                inventory: undefined,
                quantityByPerson: undefined,
                measureList: [],
                unit: undefined,
                type: undefined,
                meters: undefined,
                position: undefined,
                bedroom: undefined,
                parking: undefined,
                bathroom: undefined,
                status: 'available',
                flyerImages: [],
            });
            addValueToColumn();
        };

        function addValueToColumn() {
            vm.measureList.forEach(function (measure) {
                vm.flyer.details[vm.flyer.details.length - 1].measureList.push({
                    name: measure.name,
                    value: 0,
                });
            });
        }

        vm.addMeasures = function () {
            if (!vm.flyer.details.length) {
                if (!vm.flyer.measureList) {
                    vm.flyer.measureList = [];
                }

                if (vm.flyer.measureList.length) {
                    vm.flyer.measureList.push({ name: "", value: 0 });
                } else {
                    vm.flyer.measureList.push({
                        name: $translate.instant(
                            "flyers.new.form.weight-dimensions.height"
                        ),
                        value: 0,
                    });
                    vm.flyer.measureList.push({
                        name: $translate.instant(
                            "flyers.new.form.weight-dimensions.width"
                        ),
                        value: 0,
                    });
                }
            } else {
                vm.flyer.details.forEach(function (detail) {
                    if (!detail.measureList) {
                        detail.measureList = [];
                    }

                    if (detail.measureList.length) {
                        detail.measureList.push({ name: "", value: 0 });
                    } else {
                        detail.measureList.push({
                            name: $translate.instant(
                                "flyers.new.form.weight-dimensions.height"
                            ),
                            value: 0,
                        });
                        detail.measureList.push({
                            name: $translate.instant(
                                "flyers.new.form.weight-dimensions.width"
                            ),
                            value: 0,
                        });
                    }
                });
            }
            if (vm.measureList.length) {
                vm.measureList.push({ name: "" });
            } else {
                vm.measureList.push({
                    name: $translate.instant(
                        "flyers.new.form.weight-dimensions.height"
                    ),
                });
                vm.measureList.push({
                    name: $translate.instant(
                        "flyers.new.form.weight-dimensions.width"
                    ),
                });
            }
        };

        function findIndex(value) {
            return value.name == this;
        }

        function mapMeasures(nameMeasure) {
            if (!vm.flyer.details.length) {
                if (vm.flyer.measureList) {
                    if (
                        vm.measureList.findIndex(findIndex, nameMeasure) < 0 ||
                        nameMeasure === ""
                    ) {
                        vm.measureList.push({ name: nameMeasure });
                    }
                }
            } else {
                vm.flyer.details.forEach(function (detail) {
                    if (detail.measureList) {
                        if (
                            vm.measureList.findIndex(findIndex, nameMeasure) <
                            0 ||
                            nameMeasure === ""
                        ) {
                            vm.measureList.push({ name: nameMeasure });
                        } else {
                            if (
                                detail.measureList
                                    .map(function (el) {
                                        return el.name;
                                    })
                                    .indexOf(nameMeasure) == -1
                            ) {
                                detail.measureList.push({
                                    name: nameMeasure,
                                    value: "0",
                                });
                            }
                        }
                    } else {
                        detail.measureList = [];
                        detail.measureList.push({
                            name: nameMeasure,
                            value: "0",
                        });
                    }
                });
            }
        }

        vm.removeMeasure = function (index) {
            if (vm.measureList.length > 1) {
                vm.measureList.splice(index, 1);
                if (!vm.flyer.details.length) {
                    vm.flyer.measureList.splice(index, 1);
                } else {
                    vm.flyer.details.forEach(function (detail) {
                        detail.measureList.splice(index, 1);
                    });
                }
            }
        };

        vm.addVariation = function () {
            $uibModal
                .open({
                    templateUrl:
                        "app/admin/flyers/flyers-add-size-variation.html",
                    controller: function (selectedSizes, $uibModalInstance) {
                        var vm = this;

                        vm.tab = "classic";
                        vm.sizes = getClassicSizes();
                        vm.selectedSizes = selectedSizes;

                        vm.changeTab = function (tab) {
                            vm.tab = tab;
                            switch (tab) {
                                case "classic":
                                    vm.sizes = getClassicSizes();
                                    break;
                                case "juvenileChild":
                                    vm.sizes = getJuvenileChildSizes();
                                    break;
                                case "shorts":
                                    vm.sizes = getShortSizes();
                                    break;
                                case "plusSize":
                                    vm.sizes = getPlusSizes();
                                    break;
                                case "others":
                                    vm.sizes = vm.sizes = getOtherSizes();
                                    break;
                                default:
                                    break;
                            }
                        };

                        vm.checkSize = function (size, evt) {
                            if (evt.target.checked) {
                                vm.selectedSizes.push(size);
                            } else {
                                var index = vm.selectedSizes.indexOf(size);
                                vm.selectedSizes.splice(index, 1);
                            }
                        };

                        vm.isChecked = function (size) {
                            return selectedSizes.includes(size);
                        };

                        vm.closeModal = function () {
                            $uibModalInstance.dismiss("cancel");
                        };

                        vm.ok = function () {
                            $uibModalInstance.close(vm.selectedSizes);
                        };
                    },
                    controllerAs: "vm",
                    backdrop: "static",
                    size: "lg",
                    resolve: {
                        selectedSizes: function () {
                            return angular.copy(vm.selectedSizes);
                        },
                    },
                })
                .result.then(function (response) {
                    if (response) {
                        // Add new items
                        angular.forEach(response, function (newSize) {
                            if (!vm.selectedSizes.includes(newSize)) {
                                vm.flyer.details.push({
                                    size: newSize,
                                    purchaseValue: undefined,
                                    discountedValue: undefined,
                                    inventory: undefined,
                                    quantityByPerson: undefined,
                                    dimension: undefined,
                                    imgFlyerId: undefined,
                                    flyerImages: [],
                                    measureList: [],
                                    unit: undefined,
                                    type: undefined,
                                    meters: undefined,
                                    position: undefined,
                                    bedroom: undefined,
                                    parking: undefined,
                                    bathroom: undefined,
                                    status: undefined,
                                });
                            }
                        });

                        // Remove old items
                        angular.forEach(
                            vm.selectedSizes,
                            function (currentSize) {
                                if (!response.includes(currentSize)) {
                                    _.remove(
                                        vm.flyer.details,
                                        function (detail) {
                                            return detail.size === currentSize;
                                        }
                                    );
                                }
                            }
                        );
                        vm.selectedSizes = response;
                    }
                });
        };

        vm.removeVariation = function (index) {
            _.remove(vm.selectedSizes, function (size) {
                return vm.flyer.details[index].size === size;
            });
            vm.flyer.details.splice(index, 1);
        };

        vm.duplicateVariation = function (index) {
            var clonedItem = angular.copy(vm.flyer.details[index]);
            vm.flyer.details.push(clonedItem);
        };

        vm.replicateColumnValue = function (attribute, value) {
            var fieldPrefix = "var" + attribute.charAt(0).toUpperCase() + attribute.slice(1);
            vm.flyer.details.forEach(function (detail, index) {
                detail[attribute] = value;
                var fieldName = fieldPrefix + index;
                if (vm.flyerForm && vm.flyerForm[fieldName]) {
                    vm.flyerForm[fieldName].$setTouched();
                    vm.flyerForm[fieldName].$setDirty();
                }
                if (attribute === 'discountedValue' || attribute === 'purchaseValue') {
                    vm.checkVariationDiscountedValue(index);
                }
                if (attribute === 'purchaseValue' && typeof vm.verifyNotValid === 'function') {
                    vm.verifyNotValid(index, value);
                }
            });
        };

        // private methods
        $scope.$watch("vm.mainMap.zoom", function (newVal) {
            if (newVal > 16 && vm.firstZoom) {
                vm.mainMap.zoom = 16;
                vm.firstZoom = false;
            }
        });

        function saveFlyer() {
            if (!vm.flyer.details || vm.flyer.details.length === 0) {
                vm.isSaving = false;
                toastr.warning($translate.instant("flyers.messages.error.details"));
                return;
            }
            vm.flyer.ean = null;

            if (vm.flyer.startDate && vm.flyer.expirationDate &&
                (moment(vm.flyer.startDate, DATE_FORMAT).isSameOrAfter(moment(vm.flyer.expirationDate, DATE_FORMAT)))) {
                vm.isSaving = false;
                toastr.warning(
                    $translate.instant(
                        "error.flyerStartDateGreaterThanOrEqualsToExpirationDate"
                    )
                );
                return;
            }

            if (vm.measureList.length) {
                var obj = {};
                for (var i = 0, len = vm.measureList.length; i < len; i++) {
                    obj[vm.measureList[i]["name"]] = vm.measureList[i];
                }
                var unique = new Array();
                for (var key in obj) {
                    unique.push(obj[key]);
                }
                if (unique.length != vm.measureList.length) {
                    toastr.error(
                        $translate.instant("error.flyerDuplicateMeasures")
                    );
                    vm.isSaving = false;
                    return;
                }
            }

            if (vm.flyer.measureList && vm.flyer.measureList.length) {
                vm.flyer.measureList.forEach(function (measure, index) {
                    measure.name = vm.measureList[index].name;
                });
            } else {
                vm.flyer.details.forEach(function (detail) {
                    if (detail.imgsFlyerId)
                        detail.imgsFlyerId = detail.imgsFlyerId.toString();
                    if (detail.measureList) {
                        detail.measureList.forEach(function (measure, index) {
                            measure.name = vm.measureList[index].name;
                        });
                    }
                });
            }

            vm.existsSalesPoint = false;

            var flyerToSave = angular.copy(vm.flyer);
            flyerToSave.id = vm.isEdit ? vm.flyer.id : undefined;
            flyerToSave.isPublished = vm.flyer.isPublished
                ? vm.flyer.isPublished
                : false;

            if (!vm.isImmoContext) {
                flyerToSave.categoryKey = vm.fullCategory.key;
            }

            flyerToSave.categoryKey = flyerToSave.categoryKey
                ? flyerToSave.categoryKey
                : "OUTROS";
            flyerToSave.startDate = vm.flyer.startDate
                ? moment(vm.flyer.startDate, DATE_TIME_FORMAT).toDate()
                : now;
            flyerToSave.deliveryDate = vm.flyer.deliveryDate
                ? moment(vm.flyer.deliveryDate, DATE_FORMAT).toDate()
                : undefined;
            flyerToSave.expirationDate = vm.flyer.expirationDate
                ? moment(vm.flyer.expirationDate, DATE_TIME_FORMAT).toDate()
                : undefined;
            flyerToSave.validityTypeDate = !!vm.flyer.expirationDate;
            flyerToSave.storeId = $localStorage.defaultStore.storeId;
            flyerToSave.salesPoint = [];
            flyerToSave.currency = vm.flyer.currencyInstance.key;
            flyerToSave.gender = parseInt(vm.flyer.gender);
            flyerToSave.hub = $localStorage.defaultStore.hubId;
            flyerToSave.tags = vm.flyer.tags.map(function (tag) {
                return tag["text"];
            });

            flyerToSave.discountedValue =
                flyerToSave.discountedValue > 0
                    ? flyerToSave.discountedValue
                    : null;
            flyerToSave.brand = vm.flyer.brand.name;
            if (vm.searchColorText != "" && vm.flyer.color != null) {
                flyerToSave.color = vm.flyer.color;
            }

            vm.mainMap.markers.forEach(function (point) {
                if (point.clicked) {
                    vm.existsSalesPoint = true;
                    var newPoint = point.pointlocation;
                    newPoint.storeId = $localStorage.defaultStore.storeId;
                    newPoint.location = {
                        type: "POINT",
                        x: point.latitude,
                        y: point.longitude,
                        coordinates: [point.latitude, point.longitude],
                    };
                    flyerToSave.salesPoint.push(newPoint);
                }
            });

            if (vm.isEdit) {
                FlyersService.updateHubFlyer(flyerToSave).then(function () {
                    var params = { 'brand': flyerToSave.brand, 'category': flyerToSave.categoryKey };
                    $state.go('hub-flyers', params);
                    toastr.success($translate.instant(vm.getTranslateKey('flyers.messages.update.success')));
                    vm.isSaving = false;
                }, function (error) {
                    vm.isSaving = false;

                    if (error.status == 400) {
                        var errorValue;
                        if (error.data.data.message.includes('duplicatedEANInDatabase')) {
                            errorValue = error.data.data.data.join(", ");
                        } else if (error.data.data.message.includes('duplicatedSizeInTable')) {
                            errorValue = error.data.data.data.join(", ");
                        } else if (error.data.data.message.includes('flyers.messages.published.warning')) {
                            toastr.warning($translate.instant(error.data.data.message));
                        } else if (error.data.data.message.includes('flyers.messages.error.ri.unique')) {
                            toastr.warning($translate.instant('flyers.messages.error.ri.unique-hub') + ': ' + vm.flyer.incorporationRegister);
                            return;
                        } else {
                            errorValue = error.data.data.data;
                        }
                        toastr.warning($translate.instant(error.data.data.message, { value: errorValue }));
                    } else {
                        toastr.error($translate.instant(vm.getTranslateKey('flyers.messages.update.error.general')));
                    }

                });
            } else {
                FlyersService.createHubFlyer(flyerToSave).then(function () {
                    var params = { 'brand': flyerToSave.brand, 'category': flyerToSave.categoryKey };
                    $state.go('hub-flyers', params);
                    toastr.success($translate.instant(vm.getTranslateKey('flyers.messages.create.success')));
                    vm.isSaving = false;
                }, function (error) {
                    vm.isSaving = false;
                    if (error.status == 400) {
                        var errorValue;
                        if (error.data.data.message.includes('duplicatedEANInDatabase')) {
                            errorValue = error.data.data.data.join(", ");
                        } else if (error.data.data.message.includes('flyers.messages.published.warning')) {
                            toastr.warning($translate.instant(error.data.message));
                        } else if (error.data.data.message.includes('flyers.messages.error.ri.unique')) {
                            toastr.warning($translate.instant('flyers.messages.error.ri.unique-hub') + ': ' + vm.flyer.incorporationRegister);
                            return;
                        } else {
                            errorValue = error.data.data.data;
                        }
                        toastr.warning($translate.instant(error.data.data.message, { value: errorValue }));
                    } else {
                        toastr.error($translate.instant(vm.getTranslateKey('flyers.messages.create.error.general')));
                    }

                });
            }

        }

        vm.toggleBlueprint = function () {
            vm.hasBlueprint = !vm.hasBlueprint;
        };

        vm.isDuplicateUnit = function (currentUnit, currentIndex) {
            return vm.flyer.details.some(function (variation, index) {
                return index !== currentIndex && variation.unit === currentUnit;
            });
        };

        function loadFlyer(flyerId) {
            FlyersService.getHubFlyer(flyerId)
                .then(function (response) {
                    vm.flyer = response.data;

                    vm.flyer.deliveryDate = response.data.deliveryDate ?
                        moment.utc(response.data.deliveryDate).format(DATE_FORMAT) : undefined;

                    vm.flyer.addImageFileDTO = [];
                    if (!vm.colors.includes(vm.flyer.color)) {
                        vm.colors.push(vm.flyer.color);
                    }

                    if (vm.flyer.blueprintImages && vm.flyer.blueprintImages.length > 0) {
                        vm.toggleBlueprint();
                    }

                    if (vm.flyer.demoVideo) {
                        vm.hasLinkVideo = true;
                        vm.hasFileVideo = false;
                        vm.enableDemoVideo = true;
                    }

                    if (vm.flyer.video && vm.flyer.video.size) {
                        vm.enableDemoVideo = true;
                        vm.hasFileVideo = true;
                        vm.hasLinkVideo = false;
                        vm.fileName = vm.flyer.video.originalName;
                        vm.fileSize = vm.flyer.video.size;
                    }

                    if (!vm.flyer.flyerImages) {
                        vm.flyer.flyerImages = [];
                    }

                    if (!vm.flyer.blueprintImages) {
                        vm.flyer.blueprintImages = [];
                    }

                    if (vm.flyer.details && vm.flyer.details.length > 0) {
                        vm.flyer.details.forEach(function (detail) {
                            if (detail.flyerImages) {
                                var flyerImagesUniqueMap = new Map();
                                detail.flyerImages.forEach(function (flyerImage) {
                                    flyerImagesUniqueMap.set(flyerImage.id, flyerImage);
                                });
                                detail.flyerImages = Array.from(flyerImagesUniqueMap.values());
                            }
                        });
                    }


                    vm.flyer.currencyInstance = loadCurrencyPrefix(vm.store);
                    vm.flyer.gender = vm.flyer.gender ? vm.flyer.gender.toString() : undefined;
                    if (vm.flyer.dimension && vm.flyer.dimension.weight != null) {
                        vm.enableDimension = true;
                    }

                    if (vm.flyer.tags && vm.flyer.tags.length > 0) {
                        vm.enableTags = true;
                    } else {
                        vm.flyer.tags = [];
                    }

                    if (vm.flyer.details && vm.flyer.details.length > 0) {
                        angular.forEach(vm.flyer.details, function (detail) {
                            vm.selectedSizes.push(detail.size);
                        })

                        vm.flyer.details.forEach(function (detail) {
                            vm.enableIndiviualPrice = false;

                            if (detail.dimension && detail.dimension.weight != null && !vm.enableDimension) {
                                vm.enableDimension = true;
                            }
                            if (detail.measureList && detail.measureList.length) {
                                vm.enableMeasures = true;
                                detail.measureList.forEach(function (measure) {
                                    mapMeasures(measure.name);
                                })
                            } else {
                                detail.measureList = [];
                            }
                        });

                    } else {
                        vm.flyer.details = [];
                    }

                    if (vm.flyer.measureList && vm.flyer.measureList.length) {
                        vm.enableMeasures = true;
                        vm.flyer.measureList.forEach(function (measure) {
                            mapMeasures(measure.name);
                        })
                    }

                    if (vm.flyer.bulkQuantity) {
                        vm.enableBatchSale = true;
                    }

                    if (vm.flyer.rulesForUse) {
                        vm.enableRules = true;
                    }

                    if (vm.flyer.startDate || vm.flyer.expirationDate) {
                        vm.enableSchedules = true;
                        if (vm.flyer.startDate) {
                            vm.flyer.startDate = moment(vm.flyer.startDate).format(DATE_TIME_FORMAT)
                        }
                        if (vm.flyer.expirationDate) {
                            vm.flyer.expirationDate = moment(vm.flyer.expirationDate).format(DATE_TIME_FORMAT);
                            vm.flyer.validityTypeDate = true;
                        }
                        $timeout(function () {
                            vm.changeSchedules(vm.enableSchedules);
                        }, 200)
                    }


                    ShowcasesService.isFlyerPublished(flyerId)
                        .then(function (response) {
                            vm.flyer.isPublished = response.data;
                        });

                    if (vm.isImmoContext) {
                        if (vm.flyer.address != null && vm.flyer.address.longitude && vm.flyer.address.latitude) {
                            vm.geolocationByPoint(vm.flyer.address.latitude, vm.flyer.address.longitude)
                        }
                    }

                    vm.totalImages = vm.flyer.flyerImages.length + vm.flyer.blueprintImages.length || 0;

                    loadData();
                    initializeDropdownOptions();
                }, function () {
                    toastr.success($translate.instant('flyers.messages.load.success'));
                });
        }

        vm.verifyPurchaseNotValid = function () {
            if (vm.flyer.purchaseValue === undefined || vm.flyer.purchaseValue === null) {
                vm.flyerForm.purchaseValue.$setValidity('pattern', true);
                return;
            }

            vm.flyerForm.purchaseValue.$setValidity(
                "pattern",
                !(vm.flyer.purchaseValue <= 0)
            );
        };

        vm.verifyNotValid = function (index, value) {
            if (value === undefined || value === null) {
                vm.flyerForm["varPurchaseValue" + index].$setValidity(
                    "pattern",
                    true
                );
                return;
            }

            vm.flyerForm["varPurchaseValue" + index].$setValidity(
                "pattern",
                !(value <= 0)
            );
        };

        function loadData() {
            if ($localStorage.defaultStore && $localStorage.defaultStore.storeId != null) {
                FlyerCategoryService.listCategoriesByCurrentStore(
                    $translate.use(),
                    $localStorage.defaultStore.storeId
                ).then(function (response) {
                    vm.categories = response.data;
                    sortCategoriesByName();
                    if (vm.isEdit) {
                        vm.fullCategory = _.find(
                            vm.categories,
                            function (category) {
                                return category.key === vm.flyer.categoryKey;
                            }
                        );
                    }
                    selectedColorChange();
                    vm.isLoading = false;
                });

                vm.totalImages = vm.flyer.flyerImages.length + vm.flyer.blueprintImages.length || 0;
            }

            if (vm.isImmoContext) {
                vm.mainMap.markers = [];
            } else {
                if ($localStorage.defaultStore && $localStorage.defaultStore.storeId != null) {
                    StoreService.getSalesPoints($localStorage.defaultStore.storeId).then(function (response) {
                        convertToMarkers(response.data);
                        if (vm.isEdit) {
                            if (vm.flyer.salesPoint != null && vm.flyer.salesPoint.length > 0) {
                                vm.allSalesPoint = vm.flyer.salesPoint.length === vm.mainMap.markers.length;
                                if (vm.allSalesPoint) {
                                    vm.checkAllMarkers();
                                } else {
                                    vm.flyer.salesPoint.forEach(function (salesPoint) {
                                        for (var i = 0; i < vm.mainMap.markers.length; i++) {
                                            if (salesPoint.salesPointId == vm.mainMap.markers[i].pointlocation.salesPointId) {
                                                vm.mainMap.markers[i].clicked = true;
                                                vm.mainMap.markers[i].options.icon = ICON_ACTIVE;
                                            }
                                        }
                                    });
                                }
                            }
                        } else {
                            vm.allSalesPoint = true;
                            vm.checkAllMarkers();
                        }
                    });
                }
            }

            function sortBrandsByName() {
                vm.brands = vm.brands.sort(function (a, b) {
                    if (a.name.toLowerCase() < b.name.toLowerCase()) {
                        return -1;
                    }
                    if (a.name.toLowerCase() > b.name.toLowerCase()) {
                        return 1;
                    }
                    return 0;
                });
            }

            BrandService.getBrandsByCurrentStore().then(function (response) {
                vm.brands = response.data;
                sortBrandsByName();
                setBrandObjectOnForm();
            });
        }

        function newBrand(brand) {
            if (brand.id) {
                BrandService.editBrand(brand.id, brand).then(function (response) {
                    toastr.success(
                        $translate.instant(vm.getTranslateKey("brand.messages.success.create"))
                    );
                    vm.flyer.brand = response.data;
                    var defer = $q.defer();
                    defer.resolve(response.data);
                    vm.brands = response.data.slice();
                });
            } else {
                BrandService.createBrand(brand).then(function (response) {
                    toastr.success(
                        $translate.instant(vm.getTranslateKey("brand.messages.success.create"))
                    );
                    vm.flyer.brand = response.data;
                    var defer = $q.defer();
                    defer.resolve(response.data);
                    vm.brands = response.data.slice();
                });
            }
        }

        vm.openBrandManager = function (searchTextFromField) {
            var text = "";
            if (
                searchTextFromField != null &&
                searchTextFromField !== undefined &&
                String(searchTextFromField).trim() !== ""
            ) {
                text = String(searchTextFromField).trim();
            } else if (vm.searchText != null && vm.searchText !== undefined) {
                text = String(vm.searchText).trim();
            }
            vm.brandData = { name: text, logo: null };
            return $uibModal.open({
                templateUrl: "app/admin/brand/modal-brand.html",
                windowClass: 'modal-side-menu',
                size: 'md',
                controller: "ModalBrandController",
                controllerAs: "vm",
                backdrop: 'static',
                resolve: {
                    brand: function () {
                        return vm.brandData;
                    },
                    onFlyerForm: function () {
                        return true;
                    },
                }
            }).result.then(function (brandData) {
                if (brandData) {
                    if (brandData.name) {
                        vm.flyer.brand = brandData;
                    }
                }
            });
        };

        function querySearchBrand(query) {
            var defer = $q.defer();
            BrandService.findBrand(query === undefined ? "" : query, DEFAULT_PAGE, DEFAULT_ITEMS_PER_PAGE).then(
                function (response) {
                    var sortedData = response.data.content.sort(function (a, b) {
                        if (a.name.toLowerCase() < b.name.toLowerCase()) {
                            return -1;
                        }
                        if (a.name.toLowerCase() > b.name.toLowerCase()) {
                            return 1;
                        }
                        return 0;
                    });
                    vm.brands = sortedData.slice();
                    defer.resolve(sortedData);
                },
                function (_) {
                    defer.resolve([]);
                }
            );
            return defer.promise;
        }

        function querySearchCategory(query) {
            var results = query
                ? vm.categories.filter(createFilterFor(query))
                : vm.categories;
            var defer = $q.defer();
            defer.resolve(results);
            return defer.promise;
        }

        function createFilterFor(query) {
            var lowercaseQuery = query.toLowerCase();

            return function filterFn(category) {
                return (
                    category.title.toLowerCase().indexOf(lowercaseQuery) === 0
                );
            };
        }

        function newCategory(name) {
            if (!vm.isCreatingCategory) {
                vm.isCreatingCategory = true;
                var key = name.toUpperCase().replace(/ /g, "_");
                var category = {
                    key: key,
                    langKey: $translate.use(),
                    title: name,
                };
                var categoryDTO = {
                    key: key,
                    languages: [{ langKey: $translate.use(), title: name }],
                    categoryGroup: "OUTROS",
                };

                FlyerCategoryService.createCategoryByStore(categoryDTO).then(
                    function (response) {
                        toastr.success(
                            $translate.instant("categorys.messages.new.success")
                        );
                        vm.isCreatingCategory = false;

                        category.ownerKey = response.data.ownerKey;

                        vm.categories.push(category);
                        sortCategoriesByName();
                        selectedCategoryChange(category);
                    },
                    function () {
                        toastr.error(
                            $translate.instant("categorys.messages.new.error")
                        );
                        vm.isCreatingCategory = false;
                    }
                );
            }
        }

        function selectedCategoryChange(category) {
            if (category) {
                vm.flyer.categoryKey = category.key;
                vm.fullCategory = category;
            }
        }

        function sortCategoriesByName() {
            vm.categories = vm.categories.sort(function (a, b) {
                if (a.title.toLowerCase() < b.title.toLowerCase()) {
                    return -1;
                }
                if (a.title.toLowerCase() > b.title.toLowerCase()) {
                    return 1;
                }
                return 0;
            });
        }

        function selectedColorChange() {
            ColorService.findColor("").then(function (response) {
                var defer = $q.defer();
                defer.resolve(response.data)
                vm.colors = response.data.slice();
                var index = vm.colors.findIndex(function (value) {
                    return value.name == vm.flyer.color;
                });
                vm.flyer.color = vm.colors[index];
            });
        }

        function newColor(name) {
            ColorService.createColor(name).then(function (response) {
                toastr.success($translate.instant('color.messages.success.create'));
                vm.flyer.color = response.data
                var defer = $q.defer();
                defer.resolve(response.data)
                vm.colors = response.data.slice();
            });
        }


        vm.isSearchingColor = false;

        function querySearchColor(query) {
            vm.searchColorText = typeof query === "string" ? query.trim() : "";
            query = vm.searchColorText;
            var defer = $q.defer();
            if (query === undefined || query === "") {
                vm.isSearchingColor = false;
            } else {
                vm.isSearchingColor = true;
            }
            ColorService.findColor(query === undefined ? "" : query).then(
                function (response) {
                    defer.resolve(response.data);
                    vm.colors = response.data.slice();
                },
                function (_) {
                    deferred.resolve([]);
                }
            );
            return defer.promise;
        }

        function searchVariationColor(query) {
            query = typeof query === "string" ? query.trim() : "";
            var defer = $q.defer();
            ColorService.findColor(query === undefined ? "" : query).then(
                function (response) {
                    defer.resolve(response.data);
                    vm.colors = response.data.slice();
                },
                function (_) {
                    deferred.resolve([]);
                }
            );
            return defer.promise;
        }

        function selectedBrandChange(brand) {
        }

        function convertToMarkers(points) {
            points.forEach(function (point) {
                vm.mainMap.markers.push({
                    pointlocation: {
                        name: point.name,
                        country: point.country,
                        state: point.state,
                        neighborhood: point.neighborhood,
                        number: point.number,
                        address: point.address,
                        city: point.city,
                        salesPointId: point.id,
                        postalCode: point.postalCode,
                        contactPhone: point.contactPhone,
                        storeId: vm.store,
                    },
                    latitude: point.coordinate.latitude,
                    longitude: point.coordinate.longitude,
                    id: point.id,
                    clicked: false,
                    options: {
                        icon: ICON_INACTIVE,
                    },
                });
            });
            if (points.length === 1) {
                vm.allSalesPoint = vm.checkAllMarkers();
            }
        }

        function generateUUID() {
            var d = new Date().getTime();
            if (
                window.performance &&
                typeof window.performance.now === "function"
            ) {
                d += performance.now();
            }
            var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
                /[xy]/g,
                function (c) {
                    var r = (d + Math.random() * 16) % 16 | 0;
                    d = Math.floor(d / 16);
                    return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
                }
            );
            return uuid;
        }

        vm.isUploadingFlyer = false;

        vm.handleFileSelect = function (e) {
            var files = e.currentTarget.files;
            if (!files || !files.length) return;
            var available = 30 - vm.totalImages;
            if (available <= 0) {
                toastr.error(
                    $translate.instant("flyers.messages.error.image.quantity")
                );
                e.currentTarget.value = null;
                return;
            }
            Array.prototype.slice
                .call(files, 0, available)
                .forEach(function (file) {
                    if (file.size / 1024 > MAX_IMAGE_SIZE) {
                        toastr.error(
                            $translate.instant(
                                "flyers.messages.error.image.limit-size"
                            )
                        );
                        return;
                    }
                    var reader = new FileReader();
                    reader.onload = function (evt) {
                        $scope.PreviewImage = evt.target.result;
                        vm.isUploadingFlyer = true;
                        HubFlyersService.uploadFile(file, UPLOAD_IMAGE_CONTEXT)
                            .then(function (response) {
                                if (response.data)
                                    vm.flyer.flyerImages.push(response.data);
                                else
                                    toastr.error(
                                        $translate.instant(
                                            "flyers.messages.error.image.limit-size"
                                        )
                                    );
                                vm.isUploadingFlyer = false;
                            })
                            .catch(function () {
                                toastr.error(
                                    $translate.instant(
                                        "flyers.messages.error.image.default"
                                    )
                                );
                                vm.isUploadingFlyer = false;
                            });
                    };
                    reader.readAsDataURL(file);
                    vm.totalImages++;
                });
            // reset para permitir novos uploads
            e.currentTarget.value = null;
        };

        vm.isUploadingBlueprint = false;

        vm.handleFilePlantSelect = function (e) {

            if (vm.flyer.flyerImages && vm.flyer.blueprintImages && vm.totalImages >= 30) {
                toastr.error(
                    $translate.instant("flyers.messages.error.image.quantity")
                );
                return;
            }

            var file = e.currentTarget.files[0];
            if (file.size / 1024 > MAX_IMAGE_SIZE) {
                toastr.error(
                    $translate.instant("flyers.messages.error.image.limit-size")
                );
            } else {
                var reader = new FileReader();
                reader.onload = function (e) {
                    $scope.PreviewImage = e.target.result;
                    vm.isUploadingBlueprint = true;
                    HubFlyersService.uploadFile(file, UPLOAD_IMAGE_CONTEXT).then(
                        function (response) {
                            if (response.data === null) {
                                toastr.error(
                                    $translate.instant(
                                        "flyers.messages.error.image.default"
                                    )
                                );
                                vm.isSaving = false;
                                vm.isUploadingBlueprint = false;
                            } else {
                                vm.flyer.blueprintImages.push(response.data);
                                vm.isSaving = false;
                                vm.isUploadingBlueprint = false;
                            }
                        },
                        function () {
                            toastr.error(
                                $translate.instant(
                                    "flyers.messages.error.image.default"
                                )
                            );
                            vm.isSaving = false;
                            vm.isUploadingBlueprint = false;
                        }
                    );

                    //reset input
                    e.currentTarget.value = null;

                    vm.totalImages++;
                };
                reader.readAsDataURL(file);
            }
        };

        function checkExpirationDate() {
            if (vm.flyer.expirationDate) {
                if (
                    moment(vm.flyer.startDate, DATE_FORMAT).isSameOrAfter(
                        moment(vm.flyer.expirationDate, DATE_FORMAT)
                    )
                ) {
                    /** returns false if the expirationDate is before startDate */
                    return false;
                }
                /** returns true if the expirationDate is ok (the expirationDate is after startDate) */
                return true;
            }
        }

        function dataURItoBlob(dataURI) {
            var byteString;
            if (dataURI.split(",")[0].indexOf("base64") >= 0)
                byteString = atob(dataURI.split(",")[1]);
            else byteString = unescape(dataURI.split(",")[1]);

            var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];

            var ia = new Uint8Array(byteString.length);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }

            return new Blob([ia], {
                type: mimeString,
            });
        }

        function setBrandObjectOnForm() {
            vm.brands.forEach(function (brand) {
                if (brand.name === vm.flyer.brand) {
                    vm.flyer.brand = brand;
                    return;
                }
            });
        }

        function newVariationColor(name, variation) {
            ColorService.createColor(name).then(function (response) {
                toastr.success(
                    $translate.instant("color.messages.success.create")
                );
                variation.color = response.data;
                var defer = $q.defer();
                defer.resolve(response.data);
                vm.colors.push(response.data);
                if (variation) variation.color = response.data;
            }, function (error) {
                if (error.status == 409) {
                    toastr.warning($translate.instant("color.messages.error.duplicated"));
                } else {
                    toastr.error(
                        $translate.instant("color.messages.error.create")
                    );
                }
            });
        }

        vm.flyersSelectImageDetailModal = function (detail, isImmoContext, index) {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/admin/flyers/flyers-select-image-detail.html',
                controller: 'FlyersSelectImageDetail',
                resolve: {
                    isImmoContext: function () {
                        return vm.isImmoContext;
                    },
                    allFlyerImages: function () {
                        var allFlyerImages = [];
                        if (vm.flyer.flyerImages) {
                            var flyerImages = angular.copy(vm.flyer.flyerImages);
                            flyerImages.forEach(function (flyerImage) {
                                flyerImage.selectPosition = flyerImages.indexOf(flyerImage);
                            });
                            allFlyerImages = allFlyerImages.concat(flyerImages);
                        }
                        if (vm.flyer.blueprintImages) {
                            var offsetBlueprintImages = allFlyerImages.length;
                            var blueprintImages = angular.copy(vm.flyer.blueprintImages);
                            blueprintImages.forEach(function (blueprintImage) {
                                blueprintImage.selectPosition =
                                    offsetBlueprintImages + blueprintImages.indexOf(blueprintImage);
                            });
                            allFlyerImages = allFlyerImages.concat(blueprintImages);
                        }
                        return allFlyerImages;
                    },
                    detailFlyerImages: function () {
                        var selectedFlyerImagesMap = new Map();
                        if (!detail.flyerImages) {
                            detail.flyerImages = [];
                        }
                        detail.flyerImages.forEach(function (flyerImage) {
                            if (!selectedFlyerImagesMap.has(flyerImage.id)) {
                                selectedFlyerImagesMap.set(flyerImage.id, flyerImage);
                            }
                        })
                        return selectedFlyerImagesMap.size > 0 ? Array.from(selectedFlyerImagesMap.values()) : [];
                    },
                    identifier: function () {
                        return isImmoContext ? detail.unit : detail.size;
                    },
                },
                windowClass: 'modal-side-menu',
                backdrop: 'static',
                controllerAs: 'vm',
                keyboard: false,
            });

            var unbindRouteChange = $rootScope.$on('$locationChangeStart', function () {
                modalInstance.dismiss('route change');
            });

            modalInstance.result.then(function (detailFlyerImages) {
                if (detailFlyerImages) {
                    vm.addOrUpdateImgDetail(detailFlyerImages, index);
                }
                unbindRouteChange();
            }, function () {
                unbindRouteChange();
            });
        }

        function editVariationColor(colorData, variation) {
            ColorService.editColor(colorData).then(function (response) {
                toastr.success(
                    $translate.instant("color.messages.success.edit")
                );
                var defer = $q.defer();
                defer.resolve(response.data);
                querySearchColor("");
                getAllColors();
                if (variation && variation.color.id === colorData.id) {
                    variation.color = response.data;
                }
                vm.flyer.details.forEach(function (detail) {
                    if (detail.color.id === colorData.id) {
                        detail.color = response.data;
                    }
                });
            }, function (error) {
                if (error.status == 409) {
                    toastr.warning($translate.instant("color.messages.error.duplicated"));
                } else if (error.status == 404) {
                    toastr.warning($translate.instant("color.messages.error.notFound"));
                } else {
                    toastr.error(
                        $translate.instant("color.messages.error.edit")
                    );
                }
            });
        }

        vm.getColor = function (color) {
            if (vm.allColors && vm.allColors.length > 0) {
                var colorFound = vm.allColors.find(function (c) {
                    return c.id === color.id;
                });
                if (colorFound) {
                    return colorFound;
                }
            }
            return color;
        }

        vm.removeColor = function (color, variation, index) {
            if (vm.flyer.details.some(function (detail) {
                return detail.color && detail.color.id === color.id;
            })) {
                toastr.warning($translate.instant("color.messages.error.associated"));
                return;
            }

            ColorService.removeColor(color.id).then(function () {
                toastr.success(
                    $translate.instant("color.messages.success.remove")
                );
                querySearchColor("");
                getAllColors();
                vm.hasErrorSizeDuplicated(variation, index);
            },
                function (error) {
                    if (error.status == 409) {
                        toastr.warning($translate.instant("color.messages.error.associated"));
                    } else {
                        toastr.error(
                            $translate.instant("color.messages.error.remove")
                        );
                    }
                });
        };


        function selectVariationColor(variation, color, index) {
            vm["hidePopover" + index] = false;
            variation.color = color;
            vm.hasErrorSizeDuplicated(variation, index);
            revalidateSizes();
        }

        vm.openColorManager = function (variation, index) {
            vm["hidePopover" + index] = false;
            $uibModal
                .open({
                    templateUrl:
                        "app/admin/flyers/color-management/manage-color-modal.html",
                    controller: "ManageColorModalController",
                    controllerAs: "vm",
                    windowClass: "modal-side-menu",
                    size: "md",
                    keyboard: false,
                    resolve: {
                        color: function () {
                            return null;
                        },
                    },
                })
                .result.then(function (colorData) {
                    if (colorData) {
                        newVariationColor(colorData, variation);
                    }
                });
        };

        vm.openEditColor = function (color, variation, index) {
            var modalInstance = $uibModal.open({
                templateUrl:
                    "app/admin/flyers/color-management/manage-color-modal.html",
                controller: "ManageColorModalController",
                controllerAs: "vm",
                windowClass: "modal-side-menu",
                size: "md",
                keyboard: false,
                resolve: {
                    color: function () {
                        return angular.copy(color);
                    },
                },
            });

            modalInstance.result.then(function (colorData) {
                if (colorData) {
                    editVariationColor(colorData, variation);
                }
            });

            modalInstance.rendered.then(function () {
                angular.element('.modal').on('click', function (e) {
                    e.stopPropagation();
                });
            });
        }

        vm.openInputImage = function (evt, id) {
            document.getElementById("imgInput" + id).click();
        };

        vm.changeDemoVideo = function () {
            if (!vm.enableDemoVideo) {
                vm.flyer.demoVideo = null;
            } else {
                vm.clearFileVideo();
            }
        };

        vm.getCountDefaultImageFlyer = function () {
            var count = 0;
            vm.imgsFlyers.forEach(function (img) {
                if (img.isDefault) {
                    count++;
                }
            });
            return count;
        };

        vm.removeFlyerImage = function (id, listData) {
            var index = listData.findIndex(function (img) {
                return img.id === id;
            });
            if (index >= 0) {
                listData.splice(index, 1);
                vm.totalImages--;
            }
            if (vm.flyer.details) {
                vm.flyer.details.forEach(function (detail) {
                    if (detail.flyerImages) {
                        var detailImageIndex = detail.flyerImages.findIndex(function (img) {
                            return img.id === id;
                        });
                        if (detailImageIndex >= 0) {
                            detail.flyerImages.splice(detailImageIndex, 1);
                        }
                    }
                })
            }
        }

        vm.addOrUpdateImgDetail = function (detailFlyerImages, index) {
            vm.flyer.details[index].flyerImages = detailFlyerImages;
        }

        vm.copyToClipboard = function () {
            var copyText = document.getElementById("geocodeLink");
            copyText.select();
            copyText.setSelectionRange(0, 99999); // Para dispositivos móveis

            navigator.clipboard.writeText(copyText.value).then(function () {
                var copyIcon = document.getElementById("copyIcon");
                copyIcon.classList.remove("fa-copy");
                copyIcon.classList.add("fa-check");
                copyIcon.style.color = "green";

                setTimeout(function () {
                    copyIcon.classList.remove("fa-check");
                    copyIcon.classList.add("fa-copy");
                    copyIcon.style.color = "";
                }, 2000);
            });
        };

        vm.loadingAddress = false;
        vm.debounceTimeout = null;
        vm.debounceHandleNumber = null;

        vm.checkCEP = function () {
            if (vm.flyer.address.cep && vm.flyer.address.cep.length === 8) {
                vm.flyer.address.street = "";
                vm.flyer.address.number = "";
                vm.flyer.address.district = "";
                vm.flyer.address.city = "";
                vm.flyer.address.state = "";
                vm.flyer.address.link = "";
                vm.mainMap.markers = [];
                vm.searchAddress(vm.flyer.address.cep);
            }
        };

        vm.debounceTimeoutTest = null;
        vm.geolocationByPoint = function (lat, lng) {
            lat = lat.replace(',', '.');
            lng = lng.replace(',', '.');
            var address = lat + ',' + lng;
            if (vm.debounceTimeoutTest) {
                $timeout.cancel(vm.debounceTimeoutTest);
            }
            vm.debounceTimeoutTest = $timeout(function () {
                vm.loadingAddress = true;
                GoogleMapsService.getAddress(address).then(function (response) {
                    var latitude = lat;
                    var longitude = lng;
                    vm.mainMap.center = {
                        latitude: latitude,
                        longitude: longitude
                    };
                    vm.mainMap.markers = [{
                        latitude: latitude,
                        longitude: longitude,
                        options: {
                            icon: ICON_ACTIVE,
                            draggable: true
                        },
                        pointlocation: {
                            name: response.formatted_address,
                            address: response.formatted_address,
                            country: null,
                            state: null,
                            neighborhood: null,
                            number: null,
                            city: null,
                            postalCode: vm.flyer.address.cep,
                            contactPhone: null,
                            storeId: vm.store
                        },
                        id: 1,
                        clicked: true,
                    }];

                    vm.flyer.address.link = LINK_ADDRESS_GOOGLE + latitude + ',' + longitude;
                    vm.flyer.address.latitude = latitude;
                    vm.flyer.address.longitude = longitude;
                    vm.loadingAddress = false;
                }).catch(function (error) {
                    toastr.warning($translate.instant('flyers.messages.error.mapOnEditWithoutLocation'));
                    vm.loadingAddress = false;
                });
            }, 300);
        }

        vm.searchAddress = function (addressToSearch) {
            if (vm.debounceTimeout) {
                $timeout.cancel(vm.debounceTimeout);
            }
            vm.debounceTimeout = $timeout(function () {
                vm.loadingAddress = true;
                GoogleMapsService.getAddress(addressToSearch).then(function (response) {
                    var addressComponents = response.address_components;
                    var latitude = response.geometry.location.lat();
                    var longitude = response.geometry.location.lng();
                    vm.mainMap.center = {
                        latitude: latitude,
                        longitude: longitude
                    };
                    vm.mainMap.markers = [{
                        latitude: latitude,
                        longitude: longitude,
                        options: {
                            icon: ICON_ACTIVE,
                            draggable: true
                        },
                        pointlocation: {
                            name: response.formatted_address,
                            address: response.formatted_address,
                            country: null,
                            state: null,
                            neighborhood: null,
                            number: null,
                            city: null,
                            postalCode: vm.flyer.address.cep,
                            contactPhone: null,
                            storeId: vm.store
                        },
                        id: 1,
                        clicked: true,
                    }];

                    // gere um link compartilhavel do google maps para colocar no campo link
                    vm.flyer.address.link = LINK_ADDRESS_GOOGLE + latitude + ',' + longitude;


                    vm.flyer.address.latitude = latitude;
                    vm.flyer.address.longitude = longitude;
                    addressComponents.forEach(function (component) {
                        var types = component.types;
                        types.forEach(function (type) {
                            if (type === 'route') {
                                vm.flyer.address.street = component.long_name;
                            } else if (type === 'street_number') {
                                vm.flyer.address.number = component.long_name;
                            } else if (type === 'sublocality_level_1' || type === 'locality') {
                                vm.flyer.address.district = component.long_name;
                            } else if (type === 'administrative_area_level_2') {
                                vm.flyer.address.city = component.long_name;
                            } else if (type === 'administrative_area_level_1') {
                                vm.flyer.address.state = component.short_name;
                            } else if (type === 'postal_code') {
                                vm.flyer.address.cep = component.long_name;
                            }

                            vm.flyer.address.latitude = latitude;
                            vm.flyer.address.longitude = longitude;
                            addressComponents.forEach(function (component) {
                                var types = component.types;
                                types.forEach(function (type) {
                                    if (type === "route") {
                                        vm.flyer.address.street =
                                            component.long_name;
                                    } else if (type === "street_number") {
                                        vm.flyer.address.number =
                                            component.long_name;
                                    } else if (
                                        type === "sublocality_level_1" ||
                                        type === "locality"
                                    ) {
                                        vm.flyer.address.district =
                                            component.long_name;
                                    } else if (
                                        type === "administrative_area_level_2"
                                    ) {
                                        vm.flyer.address.city = component.long_name;
                                    } else if (
                                        type === "administrative_area_level_1"
                                    ) {
                                        vm.flyer.address.state =
                                            component.short_name;
                                    } else if (type === "postal_code") {
                                        vm.flyer.address.cep = component.long_name;
                                    }
                                });
                            });
                            vm.loadingAddress = false;
                        });
                    });
                }).catch(function (error) {
                    toastr.error(
                        $translate.instant("flyers.messages.error.map")
                    );
                    vm.loadingAddress = false;
                });;
            }, 300);
        };

        vm.toggleColorPopover = function (event, index) {
            event.stopPropagation();
            if (angular.isFunction(vm.handleClickOutsideColorPopover)) {
                vm.handleClickOutsideColorPopover(event);
            }
            if (!vm["hidePopover" + index]) {
                vm["hidePopover" + index] = true;
                createHandleClickOutsideColorPopover(index);
            }
        };

        function hideColorPopover(index) {
            if (vm["hidePopover" + index]) {
                vm["hidePopover" + index] = false;
            }
        }

        /**
         * Registers the click outside event listener only for the currently open color popover to avoid memory overload
         * @param index
         */
        function createHandleClickOutsideColorPopover(index) {
            vm.handleClickOutsideColorPopover = function (event) {
                var popoverElements = document.getElementsByClassName('color-popover-content');
                for (var i = 0; i < popoverElements.length; i++) {
                    var popoverElement = popoverElements[i];
                    if (popoverElement && !popoverElement.contains(event.target)) {
                        if ($scope.$root.$$phase) {
                            hideColorPopover(index);
                        } else {
                            $scope.$apply(function () {
                                hideColorPopover(index);
                            });
                        }
                    }
                    if (vm['hidePopover' + index] === false) {
                        // Removes the event listener when not needed anymore
                        $document.off("click", vm.handleClickOutsideColorPopover);
                        vm.handleClickOutsideColorPopover = undefined;
                    }
                }
            };

            $document.on("click", vm.handleClickOutsideColorPopover);
        }
    }
})();
